import { render, staticRenderFns } from "./punishJobDialog.vue?vue&type=template&id=8109ffd4&scoped=true"
import script from "./punishJobDialog.vue?vue&type=script&lang=js"
export * from "./punishJobDialog.vue?vue&type=script&lang=js"
import style0 from "./punishJobDialog.vue?vue&type=style&index=0&id=8109ffd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8109ffd4",
  null
  
)

export default component.exports